var React = require('react');

function Peace (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"☮"),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5 7.96456C5.76396 7.85528 6.44833 7.4993 6.96983 6.97991L5 5.66669V7.96456ZM5 4.55729L7.53379 6.24649C7.83033 5.73248 8 5.13605 8 4.5C8 2.73676 6.69615 1.27806 5 1.03544L5 4.55729ZM4 5.66669L2.03017 6.97991C2.55167 7.4993 3.23604 7.85528 4 7.96456V5.66669ZM1.46621 6.24649C1.16967 5.73248 1 5.13605 1 4.5C1 2.73676 2.30385 1.27806 4 1.03544L4 4.55729L1.46621 6.24649ZM9 4.5C9 6.98528 6.98528 9 4.5 9C2.01472 9 0 6.98528 0 4.5C0 2.01472 2.01472 0 4.5 0C6.98528 0 9 2.01472 9 4.5Z","key":1})]);
}

Peace.defaultProps = {"width":"9","height":"10","viewBox":"0 0 9 10"};

module.exports = Peace;

Peace.default = Peace;
